import { useForm, SubmitHandler } from "react-hook-form";
import { IoMdAlert } from "react-icons/io";
import { RiShieldCheckFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import logo from "../../../statics/logo/logo-cpurls.svg";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { sendEmail } from "../../../store/recover";
type FormValues = {
  email: string;
};
const Formrecover = () => {
  const { status } = useAppSelector((state) => state.recover);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();
  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(sendEmail(data.email));
  };

  return (
    <form className="c-recover-left__form" onSubmit={handleSubmit(onSubmit)}>
      <img className="c-recover-left__logo" src={logo} alt="PURLs logo" />
      <span className="c-recover-left__title">Forgot your Password?</span>
      <label className="c-recover-left__description">
        No problem! Enter your email and we will send you instructions on how to
        reset your password.
      </label>

      <div className="c-recover-left__box-input">
        <label className="c-recover-left__text-input">Your email</label>
        <input
          className="c-recover-left__input"
          type="email"
          {...register("email", {
            required: "email is required",
            pattern: {
              message: "enter a valid email",
              value: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i,
            },
          })}
        />
        {errors.email ? (
          <label className="c-login-left__text-alert">
            {errors.email?.message}
          </label>
        ) : null}
      </div>
      {status === "sendEmail_rejected" && (
        <div className="c-alert--danger">
          <IoMdAlert />
          <span>The email does not exist</span>
        </div>
      )}

      {status === "sendEmail_success" && (
        <div className="c-alert--success">
          <RiShieldCheckFill />
          <span>
            Checking your email this may take up to 3 minutes to appear in your
            inbox.
          </span>
        </div>
      )}
      <div className="c-recover-left__box-buttons">
        <button
          type="submit"
          className={`c-recover-left__button-submit ${
            status === "sendEmail_loading" &&
            `c-recover-left__button-submit--disabled`
          }`}
        >
          {status === "sendEmail_loading" ? (
            <>
              <div className="spiner"></div> Loading...
            </>
          ) : (
            <>Submit</>
          )}
        </button>
        <button
          type="button"
          className="c-recover-left__button-cancel"
          onClick={() => navigate("/")}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default Formrecover;
